import { render, staticRenderFns } from "./VerificationNewList.vue?vue&type=template&id=7571ddb2&scoped=true&"
import script from "./VerificationNewList.vue?vue&type=script&lang=js&"
export * from "./VerificationNewList.vue?vue&type=script&lang=js&"
import style0 from "./VerificationNewList.vue?vue&type=style&index=0&id=7571ddb2&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7571ddb2",
  null
  
)

export default component.exports